import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { map, Observable } from 'rxjs';
import * as selectPermissions from '../permissions/permission.selector';
import { Store } from '@ngrx/store';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    MatExpansionModule,
    MatTooltipModule,
    PermissionDirective,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  mattabnumber = 0;
  currentPath: string = '';
  allowedPath = [
    '/dashboard',
    '/inventory ',
    '/banking',
    '/branch',
    '/branch',
    '/assets',
    '/reports',
    '/roles',
    '/configure',
  ];

  @Input() collapsed!: boolean;
  @Output() collapsedChange = new EventEmitter<boolean>();

  @ViewChildren(MatExpansionPanel)
  profileName: any;
  public permissionIds: any = [];
  permissions: any;

  constructor(
    private router: Router,
    private store: Store,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (!this.authService.CURRENT_LOGGED_USER) {
      this.authService.loadUserProfile();
    }
    this.store
      .select(selectPermissions.selectPermissions)
      .subscribe((permissions) => {
        this.permissionIds = permissions;
        this.cdRef.detectChanges(); // Trigger change detection for structural directives like *appHasPermission
      });
  }

  toggleChange() {
    this.collapsedChange.emit(!this.collapsed);
  }

  navigateHome() {
    this.router.navigate(['/dashboard']);
  }

  permissionCheck() {
    this.store
      .select(selectPermissions.hasPermission('USER_MANAGEMENT'))
      .subscribe((res) => {
        console.log('permissionCheck', res);
      });
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  isRouteActive(route: string): boolean {
    return this.router.url.startsWith(route);
  }

  isRouteActive2(routes: string[]): boolean {
    const currentRoute = this.router.url;
    return routes.some((path) => this.router.url.startsWith(path));
  }
}
